import axios from 'axios'
import qs from 'qs'

const http = axios.create({
  baseURL: '',
  timeout: 60000,
  withCredentials: false,
  crossDomain: true,
  headers: {
    Authorisation: sessionStorage.getItem('s'),
    'Content-Type': 'application/json',
    CLIENT: 0x50,
  },
})

http.interceptors.request.use(
  (options) => {
    options.method = options.method || 'get'
    if (options.method === 'post') {
      const data = options.data
      if (data) {
        if (options.headers['Content-Type'] !== 'application/json') {
          options.data = options.data
        } else {
          options.data = JSON.stringify(options.data)
        }
      }
    } else if (options.method === 'get') {
      options.paramsSerializer = function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }
    return options
  },
  (error) => {
    const rObject = resultObj(
      error.response.data ? error.response.data : null,
      true
    )
    return Promise.resolve(rObject)
  }
)

http.interceptors.response.use(
  (response) => {
    return new Promise((resolve) => {
      if (response.config.responseType == 'blob' || response.config.isFile) {
        resolve(response)
        return
      }
      const rObject = resultObj(response.data, false)
      if (rObject.status == 403) {
        message.error('本次登录已过期,请重新登录', 2, () => {
          sessionStorage.clear()
          window.location.href = '/'
        })
        return
      }
      resolve(rObject)
    })
  },
  (error) => {
    if (haveObjAndObj(error.response)) {
      const rObject = resultObj(
        error.response.data ? error.response.data : null,
        true
      )
      return Promise.resolve(rObject)
    }
    const rObject = resultObj(null, true)
    return Promise.resolve(rObject)
  }
)

/**
 * 将服务器返回的结果，统一处理成一个对象返回（因为不相信后端的结果所以需要这样做）
 * 虽然后端也是返回这样的对象，但你相信后端么？方正我是不相信！那唯有自己动手不让自己前端报警
 *  请求返回的对象：｛ data, status, detail ｝
 *
 * 我们前端自己需要构造的一个对象需要在以上结果返回去构造出来
 *
 * @param res 服务器返回的结果
 * @param isCatch 当前请求是否抛异常了
 * @return { data, status, detail }
 */
const resultObj = (res, isCatch) => {
  if (isCatch) {
    if (haveObjAndObj(res)) {
      const { data, status, detail } = res
      return {
        data: data ? data : null,
        status: status || -10001,
        detail: detail || '服务器异常',
      }
    }
    return {
      data: null,
      status: -10001,
      detail: '服务器异常',
    }
  }
  let resultData = {
    data: null,
    status: -1,
    detail: '获取结果失败',
  }
  if (haveObjAndObj(res)) {
    const { data, status, detail } = res
    if (data != undefined && data != 'undefined') {
      resultData = {
        data,
        status: status || -1,
        detail: detail,
      }
    } else {
      resultData = {
        data: null,
        status: status || -1,
        detail: detail || '获取结果失败',
      }
    }
  } else {
    resultData = {
      data: isArray(res) ? res : null,
      status: -1,
      detail: !isArray(res) ? res : '获取结果失败',
    }
  }
  return resultData
}

// 判断对象是否存在且是一个对象类型
const haveObjAndObj = (res) => {
  if (
    res &&
    res != undefined &&
    res != 'undefined' &&
    res != null &&
    Object.prototype.toString.call(res) === '[object Object]'
  ) {
    return true
  }
  return false
}

const isArray = (res) => {
  return Object.prototype.toString.call(res) === '[object Array]'
}

export { http }



// WEBPACK FOOTER //
// ./src/util/http.js